var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lc-badges-overlay" }, [
    _vm.badgesData.nominee == 1
      ? _c("div", { staticClass: "badge" }, [
          _c("img", { attrs: { src: "/images/lc/04_award_nominee.png" } })
        ])
      : _vm._e(),
    _vm.badgesData.winner == 1
      ? _c("div", { staticClass: "badge" }, [
          _c("img", { attrs: { src: "/images/lc/02_category_winner.png" } })
        ])
      : _vm._e(),
    _vm.badgesData.total_winner == 1
      ? _c("div", { staticClass: "badge" }, [
          _c("img", { attrs: { src: "/images/lc/03_award_winner.png" } })
        ])
      : _vm._e(),
    _vm.badgesData.public_winner == 1 ||
    (_vm.getPlace() == 1 && !_vm.isJuryMember && _vm.isShowPubliWinner)
      ? _c("div", { staticClass: "badge" }, [
          _c("img", {
            attrs: { src: "/images/lc/01_public_voting_winner.png" }
          })
        ])
      : _vm._e(),
    _vm.getPlace() > 0 && !_vm.isJuryMember && _vm.ranking != null && false
      ? _c("div", { staticClass: "badge bordered" }, [
          _c("div", {
            staticClass: "bold",
            domProps: { textContent: _vm._s(_vm.getPlaceText()) }
          }),
          _c("div", { domProps: { textContent: _vm._s(_vm.trans("actual")) } }),
          _c("div", { domProps: { textContent: _vm._s(_vm.trans("place")) } })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }